import {useEffect, useMemo} from "react";
import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading,
	StatusLabel
} from "~/components";
import {Col, Row} from "antd";
import {
	InputField,
	SelectField
} from "~/components/Forms";
import {
	useGroup,
	useUtilities
} from "~/hooks";
import {getGroupSelectOption} from "../../../../utils";

function GroupFormAddEdit({item, onHandleSubmit}) {

	const listGroup = useGroup();

	const {utilities} = useUtilities();

	const groupOptions = Object.values(getGroupSelectOption(listGroup));

	const departmentOptions = useMemo(() => {
		return [{ value: '', label: 'Chọn phòng ban' }, ...Object.entries(utilities.departments).map(([key, group]) => {
			return {
				value: key,
				label: <StatusLabel label="Vị trí" type={group.color} small>{group.title}</StatusLabel>
			};
		})];
	}, [utilities.departments]);

	const isEdit = Boolean(item?.id);

	const initialValues = {
		name: undefined,
		parentId: undefined,
		department: 'sales',
	}

	const validationSchema = Yup.object().shape({
		name: Yup.string().required('Bạn chưa điền tên phòng kinh doanh'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if (item?.id)
		{
			reset({
				name: item.name ?? '',
				parentId: (item.parent ?? 0)+"",
				department: item.department?.key ?? 'sales'
			});
		}
		else
		{
			reset(initialValues);
		}

	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading"></p>
			<Row gutter={10}>
				<Col className="gutter-row" span={24}>
					<Controller control={control} name="name" render={({ field }) => (
						<InputField label="Tên phòng kinh doanh" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="department" render={({ field }) => (
						<SelectField label="Phòng ban" options={departmentOptions} errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="parentId" render={({ field }) => (
						<SelectField label="Cấp trên" options={groupOptions} errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm'} hợp đồng</Button>
			</div>
		</form>
	)
}

export default GroupFormAddEdit;